import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 child-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentClassExportInterface = _resolveComponent("DocumentClassExportInterface")!
  const _component_ExportInterfaceForm = _resolveComponent("ExportInterfaceForm")!
  const _component_Message = _resolveComponent("Message")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DocumentClassExportInterface, {
      rows: _ctx.rows,
      loading: _ctx.loading,
      documentClassId: _ctx.documentClassId,
      onOpenEntryDialog: _ctx.openCurrentExportInterfaceDialog,
      allExportInterfaces: _ctx.allExportInterfaces,
      onDeleteEntry: _ctx.openDeleteExportInterface,
      onOnChangeCheckbox: _ctx.onChangeCheckBox,
      onTestExportInterface: _ctx.testExportInterface
    }, null, 8, ["rows", "loading", "documentClassId", "onOpenEntryDialog", "allExportInterfaces", "onDeleteEntry", "onOnChangeCheckbox", "onTestExportInterface"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialogExportInterface,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDialogExportInterface = false, _ctx.showErrorMessage= false, _ctx.isInvalid = true, _ctx.showSharepointGraphApiErrorMessage = false, _ctx.sharepointGraphApiErrorMessageText = '')),
      onOnConfirm: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveExportInterface(true))),
      headerText: _ctx.headerText,
      loading: _ctx.loadingSave
    }, {
      content: _withCtx(() => [
        _createVNode(_component_ExportInterfaceForm, {
          fieldEntry: _ctx.exportInterfaceEntry,
          allExportInterfaces: _ctx.allExportInterfaces,
          showErrorMessage: _ctx.showErrorMessage,
          onUpdate: _ctx.onUpdateExportInterface
        }, null, 8, ["fieldEntry", "allExportInterfaces", "showErrorMessage", "onUpdate"]),
        (_ctx.showSharepointGraphApiErrorMessage)
          ? (_openBlock(), _createBlock(_component_Message, {
              key: 0,
              severity: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.sharepointGraphApiErrorMessageText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "headerText", "loading"]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.showDeleteDialogExportInterface,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDeleteDialogExportInterface = false)),
      onOnConfirm: _ctx.deleteExportInterface
    }, null, 8, ["showDialog", "onOnConfirm"])
  ]))
}